
import React from 'react';
import Button from '@/components/Buttons/Button/Button';
import ModalOverlay from '@/components/ModalOverlay/ModalOverlay';
import './BannedUserDialog.css';

interface BannedUserDialogProps {
  message: string;
  onClose: () => void;
  isDeleted?: boolean;
}

/**
 * Dialog component displayed when a banned or deleted user attempts to login.
 * Shows the backend error message and provides a way to return to home.
 * This dialog is not dismissible by clicking outside or pressing Escape.
 */
const BannedUserDialog: React.FC<BannedUserDialogProps> = ({ message, onClose, isDeleted = false }) => {
  return (
    <ModalOverlay onClose={undefined} presentation="dialog">
      <div className="banned-user-dialog" role="alertdialog" aria-modal="true" aria-labelledby="banned-dialog-title">
        <div className="banned-user-dialog-header">
          <span className="banned-user-dialog-icon" aria-hidden="true">🚫</span>
          <h2 id="banned-dialog-title">{isDeleted ? 'Account Deleted' : 'Account Suspended'}</h2>
        </div>

        <div className="banned-user-dialog-content">
          <p className="banned-user-dialog-message">{message}</p>
          <p className="banned-user-dialog-support">
            If you believe this is an error, please contact{' '}
            <a href="mailto:support@globethrivers.com" className="banned-user-dialog-link">
              support@globethrivers.com
            </a>{' '}
            for assistance.
          </p>
        </div>

        <div className="banned-user-dialog-actions">
          <Button variant="primary" onClick={onClose}>
            Return to Home
          </Button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default BannedUserDialog;
